export interface UsageLimit {
  members: { max: number; label: string };
  staff: { max: number; label: string };
}

// Define the shape of a single plan item
export interface Plan {
  _id: string;
  amount: number;
  originalAmount?: number;
  discountLabel?: string;
  bonusMonths: number;
  name: string; // e.g. "3-Month"
  months: number;
  usageLimit: UsageLimit;
  offerRate: number;
  offerStr: string | null;
  planId: string;
  productName: string;
  status: "active" | "inactive";
  featureList: string[];
  createdAt: string;
  updatedAt: string;
  isInternational: boolean;
  currency: "INR" | "USD";
  base: boolean;
  gstApplicable: boolean;
  gstPercentage: number;
  planType: "start" | "grow" | "pro";
  planLabel: string;
}

// Define the grouped output structure
export interface GroupedPlan {
  name: string; // e.g. "3-Month"
  months: number;
  plans: Plan[];
}

/**
 * Groups a flat list of plans by their duration (months).
 * @param plans - Array of Plan objects
 * @returns Array of grouped plans sorted by months ascending
 */
export function groupByDuration(plans: Plan[]): GroupedPlan[] {
  const grouped: Record<number, GroupedPlan> = {};

  for (const plan of plans) {
    const key = plan.months;

    if (!grouped[key]) {
      grouped[key] = {
        name: plan.name,
        months: plan.months,
        plans: [],
      };
    }

    grouped[key].plans.push(plan);
  }

  // Convert grouped object to array and sort by months
  return Object.values(grouped).sort((a, b) => b.months - a.months);
}
